import {
  SchemaDefinition,
  SchemaTransformError,
  UnknownSchema,
  ViewModel
} from '@rehaje/core'

import type { QuerySpecific } from './TypedNode'

export interface SchemaQuerySpecific extends RehajeSchemaMetadata {
  /**
   * Query 默认配置
   */
  default?: QuerySpecific
  type: 'Schema.Query'
  /**
   * 值
   */
  value?: any
}

export class SchemaQueryDefinition extends SchemaDefinition {
  override defaultsMerge(
    value: any,
    schema: SchemaQuerySpecific,
    initialize: boolean
  ) {
    if (initialize) {
      if (value === undefined) return schema.default
      return value
    }
    if (schema.required && value === undefined) {
      return schema.default
    }
    return value
  }

  override getIn(schema: SchemaQuerySpecific, path: PropertyKey[]) {
    if (path.length === 0) return schema
    return UnknownSchema
  }

  override infer(
    target: any,
    schema: SchemaQuerySpecific
  ): SchemaQuerySpecific {
    return this.inferOnlySchema({ ...schema, value: target })
  }

  override inferOnlySchema(schema: SchemaQuerySpecific) {
    return schema
  }

  override inferTypeScript(schema: SchemaQuerySpecific): string {
    if (schema.value instanceof ViewModel)
      return super.inferShapeTypeScript(schema.value)
    return this.interface
  }

  override prune(target: any): any {
    return target
  }

  override transform(
    target: any,
    schema: SchemaQuerySpecific,
    path: PropertyKey[] = []
  ) {
    if (this.test(target, schema, path)) return target
    if (target !== schema.fallback)
      this.raise(new SchemaTransformError(schema.name))
    return target
  }

  override validate(target: any, schema: SchemaQuerySpecific) {
    this.validateMetadata(target, schema, (target) => {
      return typeof target === 'function' || this.isRelationSpecific(target)
    })
  }
}

declare global {
  export interface RehajeSpecifics {
    'Schema.Query': SchemaQuerySpecific
  }
}
